import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import TreatmentsListBody from "components/ClinicalManagement/Treatments/TreatmentsListBody";

const Treatments = () => {
  useEffect(() => {
    document.title = "Treatments Module";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <TreatmentsListBody />
    </main>
  );
};

export default Treatments;
